import { Accordion } from "react-bootstrap";
import styles from "../Digikala.module.css";

export default function DigikalaFAQ({ faq }) {
  return (
    <div className="row rtl d-flex justify-content-center flex-wrap py-4 mt-5">
      <div className="col-12">
        <h2 className="text-secondary font-weight-bold h3 text-center">
          {faq.title}
        </h2>
      </div>

      <div className="col-12 pt-2">
        <div className="row rtl d-flex justify-content-center flex-wrap">
          {faq.questions.map((item, idx) => (
            <div className="col-12 pt-2" key={idx}>
              <div className={styles.digikalaAccordion}>
                <Accordion key={idx}>
                  <Accordion.Item eventKey={1} className="rtl-all">
                    <Accordion.Header>{item.question}</Accordion.Header>
                    <Accordion.Body>{item.answer}</Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
